import React from 'react'
import { generatePath } from 'react-router'

import { DELIVERY_RECORD_DETAILS } from 'portal/routes'

import { PageContainer } from 'portal/pages/PageContainer'
import { LineItemEdit } from 'portal/components/RecordsModules'
import { useModuleIds } from 'portal/lib/hooks'

export const DeliveryLineItemEdit = () => {
  const doneUri = useDoneRedirect()

  return (
    <PageContainer>
      <LineItemEdit doneUri={doneUri} />
    </PageContainer>
  )
}

function useDoneRedirect() {
  const { accountId, projectId, recordId, moduleName } = useModuleIds()

  return generatePath(DELIVERY_RECORD_DETAILS, {
    accountId,
    projectId,
    recordId,
    moduleName
  })
}
